import { ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { GroupForm } from "@/components/groups/group-form";
import { useCreateGroup } from "@/hooks/use-groups";
import { t } from "@/i18n/pl";

export function CreateGroupPage() {
  const navigate = useNavigate();
  const createGroup = useCreateGroup();

  return (
    <div className="animate-in fade-in slide-in-from-bottom-2 mx-auto w-full max-w-lg duration-300">
      <Button asChild variant="ghost" size="sm" className="text-muted-foreground -ml-2 mb-3">
        <Link to="/">
          <ArrowLeft aria-hidden /> {t.common.back}
        </Link>
      </Button>

      <Card>
        <CardHeader>
          <CardTitle>{t.createGroup.title}</CardTitle>
          <CardDescription>{t.createGroup.subtitle}</CardDescription>
        </CardHeader>
        <CardContent>
          <GroupForm
            pending={createGroup.isPending}
            submitLabel={t.createGroup.submit}
            onSubmit={(input) =>
              createGroup.mutate(input, { onSuccess: () => void navigate("/") })
            }
          />
        </CardContent>
      </Card>
    </div>
  );
}
